import { CSSProperties } from 'react';

interface ICenterProps {
    children: React.ReactNode;
    alignItems?: 'start' | 'end' | 'center' | 'stretch' | 'baseline';
    justifyContent?: 'start' | 'end' | 'center' | 'between' | 'around';
    width?: string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
    onDoubleClick?: () => void;
}

export const Center = (props: ICenterProps) => {
    const align = props.alignItems || 'center';
    const justify = props.justifyContent || 'center';
    const cls = props.className || '';
    const style = props.style || {};
    return (
        <div
            className={cls}
            style={{
                display: 'flex',
                position: 'relative',
                alignItems: align,
                justifyContent: justify,
                ...style
            }}
            onClick={() => {
                props.onClick && props.onClick();
            }}
            onDoubleClick={() => {
                props.onDoubleClick && props.onDoubleClick();
            }}
        >
            {props.children}
        </div>
    );
};
